import { Component, input, output } from '@angular/core';

/**
 * The shell every list filter sits in (#228, follow-up to the #59 POC): card, heading, the
 * Bootstrap grid row the fields stand in, and the „Filter zurücksetzen" action. The seven
 * filter components each carried their own copy of that markup, which is why the cards differed
 * in wrapper, heading and column widths from page to page.
 *
 *   <app-filter-card i18n-heading heading="Artikelfilter" testId="product-filter"
 *                    [canReset]="isFiltered" (reset)="resetFilter()">
 *     <div class="col-12 col-md-3"> … </div>
 *   </app-filter-card>
 *
 * Fields are projected into the row, so each filter still owns its own controls. They all use
 * the same column — `col-12 col-md-3`, the default of `<app-date-range-filter>` too — so a field
 * on one page lines up with the field on the next: four fields fill the row, fewer leave the rest
 * empty rather than stretching.
 *
 * The reset action only renders when `canReset` is bound at all: a filter that has not been
 * given a reset keeps the plain heading, instead of showing a button that does nothing.
 */
@Component({
  selector: 'app-filter-card',
  template: `
    <div class="card mb-3">
      <div class="card-body">
        <div class="d-flex align-items-center mb-3">
          <h5 class="card-title mb-0">{{ heading() }}</h5>
          @if (resettable) {
            <button
              type="button"
              class="btn btn-link btn-sm ms-auto p-0 text-decoration-none"
              [disabled]="!canReset()"
              [attr.data-testid]="testId() ? testId() + '-reset-button' : null"
              (click)="reset.emit()"
              i18n
            >
              Filter zurücksetzen
            </button>
          }
        </div>

        <div class="row g-3 align-items-end">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  styles: [':host { display: block; }'],
})
export class FilterCardComponent {
  readonly heading = input($localize`Filter`);
  /** Unbound: no reset action. Bound: the button renders, enabled while a filter is set. */
  readonly canReset = input<boolean | undefined>(undefined);
  /** Prefix for the E2E testids this shell emits (`<testId>-reset-button`). */
  readonly testId = input<string>();

  readonly reset = output<void>();

  protected get resettable(): boolean {
    return this.canReset() !== undefined;
  }
}

